import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../services/auth.service";


const AutoLogout = ({ inputValue }) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!inputValue) return;

    const handleLogout = async () => {
      try {
        await AuthService.logout(); // ✅ Call backend logout API
      } catch (error) {
        console.error("Logout API failed:", error);
      } finally {
        // Always force logout on frontend
        window.localStorage.clear();
        sessionStorage.clear();
        navigate("/"); // or "/login"
      }
    };

    const resetTimer = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(handleLogout, inputValue);
      sessionStorage.setItem("lastActivityTime", Date.now().toString());
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        sessionStorage.setItem("lastActivityTime", Date.now().toString());
      } else {
        const lastActivityTime = sessionStorage.getItem("lastActivityTime");

        if (
          lastActivityTime &&
          Date.now() - parseInt(lastActivityTime) > inputValue
        ) {
          handleLogout();
        } else {
          resetTimer();
        }
      }
    };

    const handleUserActivity = () => {
      resetTimer();
    };

    const events = ["mousemove", "mousedown", "click", "scroll", "keypress"];

    events.forEach((event) =>
      window.addEventListener(event, handleUserActivity)
    );

    window.addEventListener("visibilitychange", handleVisibilityChange);

    resetTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleUserActivity)
      );
      window.removeEventListener("visibilitychange", handleVisibilityChange);

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [inputValue, navigate]);

  return null;
};

export default AutoLogout;